import { render, staticRenderFns } from "./CenterNavigation.vue?vue&type=template&id=4ba054ca&scoped=true&"
import script from "./CenterNavigation.vue?vue&type=script&lang=js&"
export * from "./CenterNavigation.vue?vue&type=script&lang=js&"
import style0 from "./CenterNavigation.vue?vue&type=style&index=0&id=4ba054ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba054ca",
  null
  
)

export default component.exports